import type { Command } from '@atlaskit/editor-common/types';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { getParameters, setParameters } from '@atlaskit/native-embeds-common/utils';

import {
	REMIX_VERSION_TRANSITION_TRIGGER_META,
	type RemixVersionTransitionTrigger,
} from '../remix-history';

/**
 * Reads the current MAUI (remix) app/version id from a native embed node's parameters.
 */
export const getRemixAppId = (selectedNode: PMNode): string | undefined =>
	getParameters(selectedNode.attrs.parameters, 'remixAppId');

/**
 * Sets the MAUI (remix) app/version id on a native embed node's parameters.
 *
 * Because this is an ordinary node-attribute transaction, the change participates in the editor's
 * undo/redo history. Callers that know why the pointer changed can attach that trigger to the same
 * transaction so the plugin can classify the accepted transition at the ProseMirror boundary.
 */
export const createSetRemixAppIdCommand =
	(
		remixAppId: string,
		pos: number,
		selectedNode: PMNode,
		transitionTrigger?: RemixVersionTransitionTrigger,
	): Command =>
	(state, dispatch) => {
		if (dispatch) {
			const tr = state.tr.setNodeMarkup(pos, undefined, {
				...selectedNode.attrs,
				parameters: setParameters(selectedNode.attrs.parameters, { remixAppId }),
			});
			if (transitionTrigger) {
				tr.setMeta(REMIX_VERSION_TRANSITION_TRIGGER_META, transitionTrigger);
			}
			dispatch(tr);
		}
		return true;
	};
